import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { APP_ORG_REGEX } from '../components/AppSwitcherProvider';

export const isOrgPath = () => {
  return APP_ORG_REGEX.test(window.location.pathname);
};

export const getOrgId = (path: string) => {
  const match = path.match(APP_ORG_REGEX);
  return match ? match[2] : null;
};

export const isOrgRoot = () => {
  const path = window.location.pathname;
  return APP_ORG_REGEX.test(path) && /\/orgs\/\d+\/*$/.test(path);
};

export const getActiveLink = (path: string): OrgRoute | null => {
  if (path.includes('/clients')) return 'clients';
  if (path.includes('/groups')) return 'groups';
  if (path.includes('/templates')) return 'templates';
  if (path.includes('/messages')) return 'messages';
  if (path.includes('/sdk')) return 'sdk';
  if (path.includes('/settings')) return 'settings';
  if (path.includes('/users')) return 'users';
  if (path.includes('/profile')) return 'profile';
  if (path.includes('/overview')) return 'overview';
  if (path.includes('/drivers')) return 'drivers';
  if (path.includes('/deliveries')) return 'deliveries';
  if (path.includes('/dispatch')) return 'dispatch';
  if (path.includes('/inbox')) return 'inbox';
  if (path.includes('/metrics')) return 'metrics';
  if (path.includes('/flows')) return 'flows';
  if (path.includes('/api-docs')) return 'api-docs';
  // Sidecar route values are namespaced by sidecar (rather than by
  // their leaf path) to avoid colliding with future core routes — e.g.
  // 'solarbox-customers' rather than 'customers'. The match below has
  // to come BEFORE any future shorter-substring branches; ordering is
  // significant because `getActiveLink` returns on first match.
  if (path.includes('/solarbox/customers')) return 'solarbox-customers';
  if (path.includes('/solarbox/bike-control')) return 'solarbox-bike-control';
  return null;
};

export type OrgRoute =
  | 'clients'
  | 'groups'
  | 'templates'
  | 'messages'
  | 'sdk'
  | 'settings'
  | 'users'
  | 'profile'
  | 'overview'
  | 'drivers'
  | 'deliveries'
  | 'dispatch'
  | 'inbox'
  | 'metrics'
  | 'flows'
  | 'api-docs'
  | 'solarbox-customers'
  | 'solarbox-bike-control';

export const useRoute = () => {
  const { pathname } = useLocation();

  return useMemo(() => {
    const doNotShowNav =
      pathname.includes('/users/view') ||
      pathname.includes('/users/add') ||
      pathname.includes('/profile') ||
      (APP_ORG_REGEX.test(pathname) && /\/orgs\/\d+\/*$/.test(pathname));

    return {
      showNav: !doNotShowNav,
      activeLink: getActiveLink(pathname),
    };
  }, [pathname]);
};
